import type { ZoneItem } from "@/mocks/heigua";
import { zones } from "@/mocks/heigua";

const toneMap: Record<ZoneItem["tone"], { box: string; text: string; bar: string }> = {
  ember: { box: "bg-ember-100 text-ember-600", text: "text-ember-600", bar: "bg-ember-500" },
  leaf: { box: "bg-leaf-100 text-leaf-600", text: "text-leaf-600", bar: "bg-leaf-500" },
  ink: { box: "bg-cream-200 text-ink-700", text: "text-ink-700", bar: "bg-ink-700" },
};

export default function Zones() {
  return (
    <section id="zones" className="bg-cream-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-ember-600">
            <span className="h-px w-8 bg-ember-500" />
            DIRECTORY
          </p>
          <h2 className="font-serif text-2xl font-bold tracking-tight text-ink-950 md:text-4xl">
            栏目分区 · 厚壳目录
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink-600 md:text-base">
            不知道从哪吃起？先翻翻这份黑屋目录。每个分区是一扇门，进去就是一整片持续更新的内部爆料与独家内幕。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {zones.map((z, i) => {
            const t = toneMap[z.tone];
            return (
              <a key={z.name} href="#vault" className="group relative overflow-hidden rounded-xl bg-white p-5 ring-1 ring-cream-200">
                <span className={`absolute inset-x-0 top-0 h-0.5 ${t.bar}`} />
                <div className="flex items-start justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${t.box}`}>
                    <i className={`${z.icon} text-xl`} />
                  </span>
                  <span className="font-serif text-2xl font-bold text-cream-200 transition-colors group-hover:text-ember-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-semibold text-ink-950">{z.name}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-600">{z.desc}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className={`flex items-center gap-1 text-xs font-medium ${t.text}`}>
                    <i className="ri-folder-line" />
                    {z.count}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-ink-400 opacity-0 transition-opacity group-hover:opacity-100">
                    进入分区
                    <i className="ri-arrow-right-up-line" />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}